__turbopack_context__.v({
  "contentWrapper": "ArticleLayoutChrome-module-scss-module__P_6HzG__contentWrapper",
  "layoutWrapper": "ArticleLayoutChrome-module-scss-module__P_6HzG__layoutWrapper",
});
